import Tippy from '@tippyjs/react';
import React, { forwardRef } from 'react';

interface BtnRightProps {
    hint: string;
    className: string;
    help: string;
    onClick: () => void;
    icon: string;
    'data-button-id'?: string;
}

const BtnRight = forwardRef<HTMLButtonElement, BtnRightProps>(({ 
    hint, 
    className, 
    help, 
    onClick, 
    icon,
    ...props 
}, ref) => {
    return (
        <Tippy content={<span>{hint}</span>} placement="left">
            <button
                ref={ref}
                type="button"
                className={`btn btn-rounded btn-rounded-transparent aside-btn tippy ${className}`}
                aria-label={hint}
                onClick={onClick}
                {...props}
            >
                <span className="btn__icon">
                    <i className={`icon ${icon}`}></i>
                </span>
            </button>
        </Tippy>
    );
});

BtnRight.displayName = 'BtnRight';

export default BtnRight;